import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

const Container = styled.div`
    display: flex;
    flex: 1;
    flex-direction: column;
    background-color: #fafafa;
    padding: 20px;
`;

const Body = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
`;

const Content = styled.div`
    flex: 1;
    display: flex;
    flex-direction: row;
`;

const ContentContainer = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    text-align: center;
`;

const Description = styled.div`
    object-fit: contain;
    font-family: Lato;
    text-align: left;
`;

const ThankYouText = styled.span`
    color: #333;
    font-size: 14px;
    line-height: 1.3;
    font-weight: 300;
    display: inline-block;

    a {
        color: #ff245e;
        text-decoration: none;
    }
`;

const ConfirmationCard = props => (
    <Container>
        <Body>
            <Content>
                <ContentContainer>
                    {props.titleComponent}
                    <Description>
                        {props.bodyComponent ? (
                            <ThankYouText>{props.bodyComponent}</ThankYouText>
                        ) : (
                            <ThankYouText
                                dangerouslySetInnerHTML={{ __html: props.thankYouText }}
                            />
                        )}
                    </Description>
                    {props.buttonComponent && props.buttonComponent}
                    {props.fullAddress && props.getDirectionsComponent}
                </ContentContainer>
            </Content>
        </Body>
    </Container>
);

ConfirmationCard.propTypes = {
    thankYouText: PropTypes.string.isRequired,
    titleComponent: PropTypes.element.isRequired,
    bodyComponent: PropTypes.element,
    buttonComponent: PropTypes.element,
    getDirectionsComponent: PropTypes.element,
    fullAddress: PropTypes.string
};

export default ConfirmationCard;



// WEBPACK FOOTER //
// ./src/components/Shared/ConfirmationCardMultiActionsCard.jsx